import { TextCell } from '@common/components/TextCell';

interface TotalCellProps {
	total?: string;
}

export const TotalCell = ({ total }: TotalCellProps) => {
	return <TextCell value={total} weight='semibold' />;
};
